import React, { Component } from 'react';
import { numbersWithComma } from '../utils/utils';

const airIcon = 'https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg';
const seaIcon = 'https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg';
const protectedIcon = 'https://cdn.shippingcart.com/assets/protect-20231116072249.svg';
const SCProtectIcon = 'https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg';


const INSURANCE_BENEFITS = [
  'Protection against loss or damage during transit.',
  'Guaranteed on-time delivery, or your shipping fee is on us.',
  'Refund your shipping fee when returning wrong or defective items back to the merchant.',
];

class ShippingEstimateBreakdown extends Component {
  state = { 
  }

  handleFixedAirCargo(){
    if (this.props.data.air && this.props.data.air.usd.single_parcel_fixed_rate) {
      return (
        <div
          style={{
            borderBottom: "1px solid #F1F1F1",
            paddingBottom: "10px",
            marginTop: "20px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ fontWeight: 600, color: "#636363" }}>
              Fixed Air Cargo fee
            </span>
            <span>
              {`USD ${ this.props.data.air.usd.total_cargo || '0.00'}`}
            </span>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div style={{fontWeight: 600, color: '#636363', display: 'inline-flex'}}>SC Protect fee <img src={SCProtectIcon} alt='air' width={18} style={{marginLeft: '5px'}}/></div>
            <span><span style={{ marginRight: '5px' }}>+</span> 
            {`USD ${numbersWithComma(this.props.data.air.usd.total_insurance) || 0.00}`}
          </span>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '20px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <span style={{fontWeight: 600, color: '#636363'}}>Chargeable weight</span>
            <span>{this.props.data.air.usd.total_chargeable_weight} lbs</span>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <span style={{fontWeight: 600, color: '#636363', textTransform: 'capitalize'}}>Air Cargo rate</span>
            <span><span style={{ marginRight: '5px' }}>X</span> {`USD ${this.props.data.air.usd.per_pound_value || 0.00}`}</span>
          </div>
        </div>
        <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px'}}>
          <div style={{display: 'flex', justifyContent: 'right', fontWeight: 600, color: '#323232'}}>
          {`USD ${numbersWithComma(this.props.data.air.usd.total_chargeable_amount.toFixed(2)) || 0.00}`}
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <span style={{fontWeight: 600, color: '#636363'}}>Fixed handling fee</span>
            <span>
            {`USD ${numbersWithComma(this.props.data.air.usd.total_fixed_rate && this.props.data.air.usd.total_fixed_rate.toFixed(2)) || 0.00}`}
          </span>
          </div>
        </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div style={{fontWeight: 600, color: '#636363', display: 'inline-flex'}}>SC Protect fee <img src={SCProtectIcon} alt='air' width={18} style={{marginLeft: '5px'}}/></div>
            <span><span style={{ marginRight: '5px' }}>+</span> 
            {`USD ${numbersWithComma(this.props.data.air.usd.total_insurance) || 0.00}`}
          </span>
          </div>
      </div>
    )
  }

  render() {
    const minChargableWeight = this.props.minChargableWeight && JSON.parse(this.props.minChargableWeight.settings);
    return (
      <div>
        {this.props.offSize ? null : <div style={{padding: '20px 16px', fontSize: '16px'}}>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <img src={airIcon} alt='air' width={24}/>
            <div style={{display: 'flex', flexDirection: 'column', marginLeft: '5px'}}>
              <span style={{color: '#323232', fontWeight: 600, textTransform: 'capitalize'}}>Air Cargo</span>
              <span style={{fontSize: '10px', color: '#323232'}}>Est. delivery: {this.props.data.delivery.air}</span>
            </div>
            </div>
          {this.handleFixedAirCargo()}
          <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
            <span style={{fontWeight: 600, color: '#323232', textTransform: 'capitalize'}}>Total Air Cargo Fee</span>
            <span style={{fontWeight: 600, color: '#323232'}}>
              {`USD ${numbersWithComma(this.props.data.air.usd.total_price.toFixed(2)) || 0.00}`}
            </span>
          </div>
        </div>}
        {this.props.offSize || this.props.destination === "MY" ? null : <hr style={{margin: '10px 16px'}}/>}
        {this.props.destination === "MY" ? null : <div style={{padding: '20px 16px', fontSize: '16px'}}>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <img src={seaIcon} alt='sea' width={24}/>
            <div style={{display: 'flex', flexDirection: 'column', marginLeft: '5px'}}>
              <span style={{color: '#323232', fontWeight: 600, textTransform: 'capitalize'}}>Sea Cargo</span>
              <span style={{fontSize: '10px', color: '#323232'}}>Est. delivery: {this.props.data.delivery.sea}</span>
            </div>
          </div>
          <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '20px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <span style={{fontWeight: 600, color: '#636363'}}>Chargeable weight</span>
              <span>{this.props.data.sea.usd.total_chargeable_weight} lbs</span>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <span style={{fontWeight: 600, color: '#636363', textTransform: 'capitalize'}}>Sea Cargo rate</span>
              <span><span style={{ marginRight: '5px' }}>X</span> {`USD ${this.props.data.sea.usd.per_pound_value || 0.00}`}</span>
            </div>
            {this.props.data.sea && 
              this.props.data.sea.usd.is_sea_higher_rate && <div style={{fontSize: '10px', fontStyle: 'italic'}}>Higher rates apply if any side of a package is over {minChargableWeight && minChargableWeight.sea_max_dimension && minChargableWeight.sea_max_dimension.value} inches.</div>}
          </div>
          <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px'}}>
            <div style={{display: 'flex', justifyContent: 'right', fontWeight: 600, color: '#323232'}}>
            {`USD ${numbersWithComma(this.props.data.sea.usd.total_chargeable_amount.toFixed(2)) || 0.00}`}
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <span style={{fontWeight: 600, color: '#636363'}}>Fixed handling fee</span>
              <span>
              {`USD ${numbersWithComma(this.props.data.sea.usd.total_fixed_rate && this.props.data.sea.usd.total_fixed_rate.toFixed(2)) || 0.00}`}
            </span>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <div style={{fontWeight: 600, color: '#636363', display: 'inline-flex'}}>SC Protect fee <img src={SCProtectIcon} alt='sea' width={18} style={{marginLeft: '5px'}}/></div>
              <span><span style={{ marginRight: '5px' }}>+</span> 
              {`USD ${numbersWithComma(this.props.data.sea.usd.total_insurance) || 0.00}`}
            </span>
            </div>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
            <span style={{fontWeight: 600, color: '#323232', textTransform: 'capitalize'}}>Total Sea Cargo Fee</span>
            <span style={{fontWeight: 600, color: '#323232'}}>
              {`USD ${numbersWithComma(this.props.data.sea.usd.total_price.toFixed(2)) || 0.00}`}
            </span>
          </div>
        </div>}

        <div style={{border: '1px solid #0375D9', backgroundColor: '#E5F1FB', padding: '20px', borderRadius: '10px', margin: '20px 16px'}}>
          <div style={{color: '#636363', fontWeight: 600}}>
            Benefits of SC Protect:
          </div>
          <div style={{marginTop: '10px', color: '#323232'}}>
          {INSURANCE_BENEFITS.map((benefit, index) => (
            <div style={{ marginBottom: '8px', display: 'flex' }} key={index}>
              <div style={{marginRight: '5px'}}>
                <img
                  src={protectedIcon }
                  alt="icon"
                />
              </div>
              {benefit}
            </div>
          ))}
          </div>

          {this.props.data.insurance_eligible === 1 && <div style={{display: 'flex', justifyContent: 'space-between',marginTop: '10px', alignItems: 'center'}}>
                <img src={SCProtectIcon} alt='badge' width={24} height={24} style={{ marginRight: '5px' }}/>
                <span style={{fontSize: '10px', fontWeight: 600, color: '#636363'}}>SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.</span>
              </div>}
        </div>
      </div>
      
    )
  }
}
export default ShippingEstimateBreakdown;


/** WEBPACK FOOTER **
 ** ./src/components/ShippingEstimateBreakdown.js
 **/